// Tracks affiliate attribution: reads ?ref= from URL on landing,
// stores a 90-day visitor token + ref code in localStorage,
// hits backend to register the attribution.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

function getOrCreateVisitorToken() {
  let t = localStorage.getItem("nc_visitor");
  if (!t) {
    t = (crypto.randomUUID && crypto.randomUUID()) ||
        Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("nc_visitor", t);
  }
  return t;
}

export default function AffiliateTracker() {
  const loc = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const code = params.get("ref");
    const visitor_token = getOrCreateVisitorToken();
    if (code) {
      // Persist for later attach-on-login
      localStorage.setItem("nc_ref", code);
      api.post("/affiliate/track", { code, visitor_token }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.search]);

  // Once user logs in, attach attribution to their account
  useEffect(() => {
    if (!user) return;
    const visitor_token = localStorage.getItem("nc_visitor");
    if (!visitor_token) return;
    api.post(`/affiliate/attach-user?visitor_token=${encodeURIComponent(visitor_token)}`).catch(() => {});
  }, [user]);

  return null;
}
